import {CompanyMemberRole} from "./companyMember";

export enum NotificationType {
    ANNOUNCEMENT = "ANNOUNCEMENT",
    INVITATION = "INVITATION",
    FIELD_RESULTS = "FIELD_RESULTS",
}

export enum NotificationStatus {
    SENT = "SENT",
    SCHEDULED = "SCHEDULED",
    DRAFT = "DRAFT",
    CANCELLED = "CANCELLED",
}

export enum NotificationTargetPlatform {
    WEB = "WEB",
    MOBILE = "MOBILE",
}

export interface AnnouncementTranslatedContent {
    shortText: string;
    content: string;
    title: string;
}

export interface AnnouncementMetaData {
    content?: Record<string, AnnouncementTranslatedContent> | null;
}

export interface Notification {
    id?: string;
    type: NotificationType;
    name: string;
    startTime: string | null;
    status: NotificationStatus;
    targetAll?: boolean | null;
    targetUsers?: string[] | null;
    targetCompanies?: string[] | null;
    targetRoles?: CompanyMemberRole[] | null;
    targetPlatforms?: NotificationTargetPlatform[] | null;
    metaData?: AnnouncementMetaData;
    createdBy?: string;
    seen?: string[] | boolean;
    expirationDate?: Date | null;
    createdAt?: Date;
    updatedAt?: Date;
}
